import { useCallback, useEffect, useState } from 'react';
import { NOTIFICATION_TRAY_PAGE_SIZE } from '../constants/notificationTrayUi';

/**
 * Client-side tray pagination: show PAGE_SIZE at a time, then expand by PAGE_SIZE.
 * Resets to the first page whenever the list empties (e.g. all marked read).
 */
export function useNotificationTrayPagination(itemCount: number) {
  const [visibleCount, setVisibleCount] = useState(NOTIFICATION_TRAY_PAGE_SIZE);

  useEffect(() => {
    if (itemCount === 0) {
      setVisibleCount(NOTIFICATION_TRAY_PAGE_SIZE);
    }
  }, [itemCount]);

  const effectiveVisible = Math.min(visibleCount, itemCount);
  const hasMore = itemCount > visibleCount;
  const remaining = Math.max(0, itemCount - visibleCount);

  const loadMore = useCallback(() => {
    setVisibleCount((prev) => prev + NOTIFICATION_TRAY_PAGE_SIZE);
  }, []);

  return {
    visibleCount: effectiveVisible,
    hasMore,
    remaining,
    loadMore,
    pageSize: NOTIFICATION_TRAY_PAGE_SIZE,
  };
}
